import { render, staticRenderFns } from "./DateCoachBasic.vue?vue&type=template&id=3084ac0c&scoped=true"
import script from "./DateCoachBasic.vue?vue&type=script&lang=js"
export * from "./DateCoachBasic.vue?vue&type=script&lang=js"
import style0 from "./DateCoachBasic.vue?vue&type=style&index=0&id=3084ac0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084ac0c",
  null
  
)

export default component.exports